import { IRealizedBudget } from '@/modules/dashboardBrandManagement/types';
import store from '@/store';

interface ISeriesChart {
  balance: number[];
  real: number[];
  positive: string[];
  richSeries: any;
  positiveColor: string[];
  balanceMask: string[];
  realMask: string[];
  budgeted: number[];
}

export const seriesChart = (realized: IRealizedBudget[]): ISeriesChart => {
  const balance: number[] = realized.map(
    (realizedBudget) => realizedBudget.balance
  );

  const real: number[] = realized.map((realizedBudget) => realizedBudget.real);

  const positive: string[] = realized.map((realizedBudget) =>
    realizedBudget.positive === true ? '#219653' : '#E70024'
  );

  const positiveColor: string[] = realized.map((realizedBudget) =>
    realizedBudget.positive === true ? 'Positive' : 'Negative'
  );

  const brands: string[] = realized.map((realizedBudget) =>
    realizedBudget.brand.toLowerCase()
  );

  const richSeries = () => {
    const rich = [{}];
    brands.forEach((brand) => {
      rich[0][brand] = {
        height: 18,
        align: 'center',
        lineHeight: 27,
        verticalAlign: 'bottom',
        padding: [0, 0, 0, 0],
        backgroundColor: {
          image: store.state.auth.brands?.find(
            (brandStore) =>
              brand.toUpperCase() === brandStore.name.toUpperCase()
          )?.logo,
        },
      };
    });
    return rich;
  };

  const balanceMask: string[] = realized.map(
    (realizedBudget) => realizedBudget.balanceMask
  );

  const realMask: string[] = realized.map(
    (realizedBudget) => realizedBudget.realMask
  );

  const budgeted: number[] = realized.map(
    (realizedBudget) => realizedBudget.budgeted
  );

  return {
    balance,
    real,
    positive,
    richSeries,
    positiveColor,
    balanceMask,
    realMask,
    budgeted,
  };
};
